export default "__VITE_ASSET__h4_k2PFw__"